// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32oVr","content":"styles_content__D7qBb"};